var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({key:_vm.appKey,staticClass:"app starting",attrs:{"id":"app"}},'div',_vm.app,false),[_c('UpdateAvailable'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }